import React from "react";
import { Navigate } from "react-router-dom";

/******************* nouveaux routes ****************** */
const LoginRoute = React.lazy(() => import("./views/login"));
const error = React.lazy(() => import("./views/errorPage.js"));
const home = React.lazy(() => import("./views/Home.jsx"));

/**************************************** */
/********************** navettes********* */
/**************************************** */
const navette_create = React.lazy(() => import("./views/navettes/Create.jsx"));
const navette_list = React.lazy(() => import("./views/navettes/List.jsx"));
const navette_single = React.lazy(
  () => import("./views/navettes/NavetteSingle.jsx"),
);

/**************************************** */
/********************** missions********* */
/**************************************** */

//admin
const mission_create = React.lazy(
  () => import("./views/missions/MissionCreate.jsx"),
);
const missions_list_admin = React.lazy(
  () => import("./views/missions/admin/MissionsAdminList.jsx"),
);
const missions_single_admin = React.lazy(
  () => import("./views/missions/admin/MissionsAdminSingle.jsx"),
);

const missions_single_admin_direct = React.lazy(
  () => import("./views/missions/admin/MissionsAdminSingleDirect.jsx"),
);

const missions_supervision_admin = React.lazy(
  () => import("./views/maps/MapSupervisionMissions.jsx"),
);

//agence
const missions_list_agence = React.lazy(
  () => import("./views/missions/agence/MissionsAgenceList.jsx"),
);
const missions_single_agence = React.lazy(
  () => import("./views/missions/agence/MissionsAgenceSingle.jsx"),
);

const missions_print_agence = React.lazy(
  () => import("./views/missions/OrdreMission.jsx"),
);

//convoyeur
const missions_list_convoyeur = React.lazy(
  () => import("./views/missions/convoyeur/MissionsConvoyeurList.jsx"),
);
const missions_single_convoyeur = React.lazy(
  () => import("./views/missions/convoyeur/MissionsConvoyeurSingle.jsx"),
);

/**************************************** */
/********************** parcels ********* */
/**************************************** */
const parcelsInEtape = React.lazy(
  () => import("./views/colis/ExpeditionsAndReceptions.jsx"),
);

const parcelsHistory = React.lazy(
  () => import("./views/colis/ParcelHistory.jsx"),
);

const parcelsReport = React.lazy(
  () => import("./views/colis/ParcelReporting.jsx"),
);

const parcelsHistoryAgence = React.lazy(
  () => import("./views/colis/ParcelsHistoryByHub.jsx"),
);
const parcelsLostAndFound = React.lazy(
  () => import("./views/colis/LostAndFound.jsx"),
);

/**************************************** */
/******************** operations********* */
/**************************************** */
const missionOperation = React.lazy(
  () => import("./views/operations/MissionAgence.jsx"),
);
const missionOperationConvoyeur = React.lazy(
  () => import("./views/operations/MissionConvoyeur.jsx"),
);

const expeditionOperation = React.lazy(
  () => import("./views/operations/Expedition.jsx"),
);
const receptionOperation = React.lazy(
  () => import("./views/operations/Reception.jsx"),
);

/**************************************** */
/******************** statistiques********* */
/**************************************** */

// Tableaux de bord statistiques
const stats_missions = React.lazy(
  () => import("./views/stats/MissionsStats.jsx"),
);
const stats_missions_agency_stats = React.lazy(
  () => import("./views/stats/MissionsAgencyStats.jsx"),
);
const stats_missions_distance_duration = React.lazy(
  () => import("./views/stats/MissionsDistanceDuration.jsx"),
);
const stats_missions_pauses_anomalies = React.lazy(
  () => import("./views/stats/MissionsPausesAnomalies.jsx"),
);

const stats_parcel = React.lazy(() => import("./views/stats/ParcelsStats.jsx"));

const routes = [
  // PUBLIC
  { path: "/login", exact: true, name: "Login", element: LoginRoute },
  { path: "/error", exact: true, name: "Error", element: error },
  // Redirection globale
  { path: "*", element: <Navigate to="/login" replace /> },
  // Accueil
  { path: "/home", exact: true, name: "home", element: home },

  /*** navetes */
  {
    path: "/navettes/create",
    exact: true,
    name: "navette_create",
    element: navette_create,
    roles: ["create_shuttle"],
  },
  {
    path: "/navettes/list",
    exact: true,
    name: "navette_list",
    element: navette_list,
    roles: [],
  },
  {
    path: "/navettes/:navetteId",
    exact: true,
    name: "navette_single",
    element: navette_single,
    roles: [],
  },

  /*** missions */
  {
    path: "/missions/create",
    exact: true,
    name: "mission_create",
    element: mission_create,
    roles: ["create_mission"],
  },
  {
    path: "/missions/admin/list",
    exact: true,
    name: "missions_admin_list",
    element: missions_list_admin,
    roles: ["read_missions_admin"],
  },
  {
    path: "/missions/admin/:missionId",
    exact: true,
    name: "missions_admin_single",
    element: missions_single_admin,
    roles: ["read_missions_admin"],
  },
  {
    path: "/missions/admin/single-direct",
    exact: true,
    name: "missions_admin_single_direct",
    element: missions_single_admin_direct,
    roles: ["read_missions_admin"],
  },
  {
    path: "/missions/admin/supervision",
    exact: true,
    name: "missions_supervision_admin",
    element: missions_supervision_admin,
    roles: ["read_missions_supervision"],
  },
  {
    path: "/missions/agence/list",
    exact: true,
    name: "missions_list_agence",
    element: missions_list_agence,
    roles: ["read_missions_agency"],
  },
  {
    path: "/missions/agence/:id",
    exact: true,
    name: "missions_single_agence",
    element: missions_single_agence,
    roles: ["read_missions_agency"],
  },
  {
    path: "/missions/print/:missionId",
    exact: true,
    name: "missions_print_agence",
    element: missions_print_agence,
    roles: ["read_missions_agency"],
  },
  {
    path: "/missions/convoyeur/list",
    exact: true,
    name: "missions_convoyeur_list",
    element: missions_list_convoyeur,
    roles: ["read_missions_convoyeur"],
  },
  {
    path: "/missions/convoyeur/:missionId",
    exact: true,
    name: "missions_convoyeur_single",
    element: missions_single_convoyeur,
    roles: ["read_missions_convoyeur"],
  },

  /*** parcels */
  {
    path: "/parcels/expeditions_receptions/:etapeId",
    exact: true,
    name: "expeditions_receptions",
    element: parcelsInEtape,
    roles: ["read_parcels_summary"],
  },
  {
    path: "/parcels/history",
    exact: true,
    name: "parcelsHistory",
    element: parcelsHistory,
    roles: ["read_parcel_history"],
  },
  {
    path: "/parcels/history-agence",
    exact: true,
    name: "parcelsHistoryAgence",
    element: parcelsHistoryAgence,
    roles: ["read_stats"],
  },
  {
    path: "/parcels/report",
    exact: true,
    name: "parcelsReport",
    element: parcelsReport,
    roles: ["read_stats"],
  },
  {
    path: "/parcels/lost-found",
    exact: true,
    name: "parcels_lost_found",
    element: parcelsLostAndFound,
    roles: ["read_stats"],
  },

  /*** operations */
  {
    path: "/operations/mission/agence",
    exact: true,
    name: "missionOperation",
    element: missionOperation,
    roles: ["read_missions_agency"],
  },
  {
    path: "/operations/mission/convoyeur",
    exact: true,
    name: "missionOperationConvoyeur",
    element: missionOperationConvoyeur,
    roles: ["read_missions_convoyeur"],
  },
  {
    path: "/operations/expedition",
    exact: true,
    name: "expeditionOperation",
    element: expeditionOperation,
    roles: ["expedite_parcels_agency"],
  },
  {
    path: "/operations/reception",
    exact: true,
    name: "receptionOperation",
    element: receptionOperation,
    roles: ["receive_parcels_agency"],
  },

  /*** statistiques */
  {
    path: "/stats/missions",
    exact: true,
    name: "stats_missions",
    element: stats_missions,
    roles: ["read_stats"],
  },
  {
    path: "/stats/missions/agency",
    exact: true,
    name: "stats_missions_agency_stats",
    element: stats_missions_agency_stats,
    roles: ["read_stats"],
  },
  {
    path: "/stats/missions/distance-duration",
    exact: true,
    name: "stats_missions_distance_duration",
    element: stats_missions_distance_duration,
    roles: ["read_stats"],
  },
  {
    path: "/stats/missions/pauses-anomalies",
    exact: true,
    name: "stats_missions_pauses_anomalies",
    element: stats_missions_pauses_anomalies,
    roles: ["read_stats"],
  },

  {
    path: "/stats/parcels",
    exact: true,
    name: "stats_parcel",
    element: stats_parcel,
    roles: ["read_stats"],
  },
];

export default routes;
